<div (click)="openPopup($event)" tappable>{{ valueState() | CompanyLocalized : 'timeFormat' }}</div>

